import { AuditNote } from '@cdab/scania/qpr/components/atoms'
import styled from 'styled-components'

export const NoteTextareaWrapper = styled(AuditNote)`
  margin-bottom: var(--tds-spacing-element-12);
`
